<template>

         <v-card>
         <v-card-title>
            <span class="headline">Edit Contact</span>
         </v-card-title>

      <v-card-text>
            <v-container>
               <v-row>
               <v-col 
                 cols="12"
                  sm="6"
                  md="6">

                   <v-select
                     v-model="contact.center"
                     :items="centerItems"
                      item-text="name"
                      item-value="id"
                     label="Center"
                  ></v-select>
               </v-col>

                    <v-col 
                 cols="12"
                  sm="6"
                  md="6"
               >
                <v-select
                     v-model="contact.status"
                     :items="statusItems"
                     label="Status"
                  ></v-select>
               </v-col>

               <v-col 
                 cols="12"
               >
                <v-select
                     v-model="contact.type"
                     :items="typeItems"
                     label="Type"
                  ></v-select>
               </v-col>

               
         
               </v-row>
            </v-container>
         </v-card-text>
         <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
               color="darken-1"
               text
               @click="closeDialog"
            >
               Close
            </v-btn>
            <v-btn
               color="blue darken-1"
               text
               @click="closeDialog"
            >
               Save
            </v-btn>
         </v-card-actions>

  
      </v-card>

</template>


<script>
import { mapGetters } from "vuex";

    export default {
       
       props: ["contactInformation"],
       data: () => ({
         fab: false,
         contact:[],

         centerItems:[],
         statusItems:["Inquiry", "Sheepshead Bay", "Downtown Brooklyn"],
         typeItems:["Individual", "School"],

       
       }),
      computed: {
         ...mapGetters(["myCenters"]),
      },
      methods: {
         closeDialog () {
            this.$emit('mclosedialog');
         },
      },
      mounted() {
        this.contact = this.contactInformation;
        this.centerItems = this.myCenters

        console.log(this.contactInformation)
        console.log(this.centers)


      }
     }
</script>
